import { atom, selector } from "recoil";

export const alertListState = atom({
  key: 'alertListState',
  default: []
});

export const addAlertStateSelector = selector({
  key: 'addAlertStateSelector',
  set: ({get, set}, alertInfo) => {
    const oldList = get(alertListState);
    const newList = [...oldList, alertInfo];
    set(alertListState, newList);
  }
});

export const removeAlertStateSelector = selector({
  key: 'removeAlertStateSelector',
  set: ({get, set}, alertInfo) => {
    const oldList = get(alertListState);
    const idx = oldList.findIndex(target => {
      return target.id === alertInfo.id;
    });
    if (idx === -1) return;

    const newList = [...oldList.slice(0, idx), ...oldList.slice(idx + 1)];
    set(alertListState, newList);
  }
});